import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Box, Modal, Paper } from "@mui/material"
import Loader from "@components/ui/Loader/Loader"
import FormAviso, { FormDataAviso } from "@components/FormParte/FormAviso"
import { avisosService } from "@services/avisos"
import "./AvisoDefinitivoIndividual.scss"
import moment from "moment"

const AvisoDefinitivoIndividual = ({ isEditing = false }) => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [initialData, setInitialData] = useState<FormDataAviso | null>(null)
  const [isLoadingData, setIsLoadingData] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)

  useEffect(() => {
    let componentMounted = true

    if (id) {
      const fetchAviso = async () => {
        setIsLoadingData(true)
        try {
          const resp = await avisosService.getByUniqueId(id)
          if (componentMounted) setInitialData({ ...resp?.data?.data, date: moment(resp?.data?.data?.date), time: moment(resp?.data?.data?.time) })
        } catch {
          handleClose()
        } finally {
          if (componentMounted) setIsLoadingData(false)
        }
      }

      fetchAviso()
    }

    return () => {
      componentMounted = false
    }
  }, [id])

  const handleSave = async (form: FormDataAviso) => {
    setIsSaving(true)

    try {
      const response = await avisosService.modify(form);
      handleClose()
    } catch (error) {
      console.error(error)
    } finally {
      setIsSaving(false)
    }
  }

  const handleClose = () => {
    navigate("/avisos")
  }

  return (
    <Modal
      open={true}
      onClose={handleClose}
      aria-labelledby="modal-modal-aviso-title"
      aria-describedby="modal-modal-aviso-description"
    >
      <div className="see-modal">
        <Paper
          elevation={3}
          sx={{
            maxWidth: 1048,
            margin: "auto",
            borderRadius: "25px",
            paddingBottom: "30px",
          }}
        >
          {isLoadingData ? (
            <Box className="ml-20 mr-20 mt-40">
              <Loader message="Cargando datos del aviso" />
            </Box>
          ) : (
            <>
              <div className="paper-header">
                {!isEditing ? (
                  <h5>Nº Aviso {initialData ? initialData.notification : ""}</h5>
                ) : (
                  <h5>Editar Nº Aviso {initialData ? initialData.notification : ""}</h5>
                )}
              </div>
              <Box className="ml-20 mr-20 mt-40">
                <FormAviso
                  initialData={initialData}
                  handleClose={handleClose}
                  editable={isEditing}
                  isSaving={isSaving}
                  handleSave={isEditing ? handleSave : undefined}
                  isNewAviso={false}
                />
              </Box>
            </>
          )}
        </Paper>
      </div>
    </Modal>
  )
}

export default AvisoDefinitivoIndividual